import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing orders.
 */

/**
 * Service class for handling orders.
 */
class OrderPaymentService {
  /**
   * Retrieves the details of a orders based on the provided parameters.
   *
   * @param params - The parameters for retrieving the orders details.
   * @returns A Promise that resolves to the Axios response containing the orders details.
   */
  static viewOrderPaymentDetails(params: any) {
    return client.get(
      `admin/order-payment/get-order-payment?order_id=${params.order_id}`
    );
  }
}

export { OrderPaymentService };
